var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-permission",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41896",
    "data-name": "Path 41896",
    d: "M7.421,14a3.316,3.316,0,0,1-3.253-3.375A3.316,3.316,0,0,1,7.421,7.25a3.316,3.316,0,0,1,3.253,3.375A3.323,3.323,0,0,1,7.421,14Zm0-5.25a1.876,1.876,0,1,0,1.807,1.875A1.842,1.842,0,0,0,7.421,8.75Zm7.228,1.5a4.052,4.052,0,0,1-3.976-4.125A4.052,4.052,0,0,1,14.649,2a4.052,4.052,0,0,1,3.976,4.125A4.06,4.06,0,0,1,14.649,10.25Zm0-6.75a2.579,2.579,0,0,0-2.53,2.625,2.532,2.532,0,1,0,5.06,0A2.579,2.579,0,0,0,14.649,3.5ZM8.867,23H5.976a4.128,4.128,0,0,1,0-8.25H8.867a4.128,4.128,0,0,1,0,8.25ZM5.976,16.25a2.627,2.627,0,0,0,0,5.25H8.867a2.627,2.627,0,0,0,0-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41897",
    "data-name": "Path 41897",
    d: "M19.831,26.438H11.768a.763.763,0,1,1,0-1.525h8.063a4.194,4.194,0,1,0,0-8.388H15.224a.763.763,0,1,1,0-1.525h4.608a5.719,5.719,0,1,1,0,11.438Z",
    transform: "translate(-2.591 -3.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPermission);
export default __webpack_public_path__ + "static/media/group_permission.efa2bfd35507907754d6603c47144756.svg";
export { ForwardRef as ReactComponent };